import React, { useState, useEffect } from "react";
import _ from "lodash";
import Select from "react-select";
import { getJobManagements } from "./Axios";

const ManagementsSelect = ({ divisionId, uniqueId, value, handleChange }) => {
  const [managements, setManagements] = useState([]);

  useEffect(() => {
    if (divisionId) {
      getManagements(divisionId);
    }
  }, [divisionId]);

  const getManagements = (divisionId) => {
    getJobManagements(divisionId, (response) => {
      if (response?.data) {
        const newManagements = response.data.map((management) => ({
          value: management.id,
          label: management.name,
          uniqueIdentifier: management.unique_identifier,
        }));
        setManagements(newManagements);
      }
    });
  };

  return (
    <Select
      inputId={uniqueId}
      onChange={(selectedOption) => handleChange(selectedOption, "management")}
      options={managements}
      placeholder="Seleccione una opción"
      value={
        managements.find((option) => option.value === value?.value) || null
      }
      getOptionLabel={(e) => `${e.label} (${e.uniqueIdentifier})`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label, uniqueIdentifier } = option.data;
        return (
          label.toLowerCase().includes(searchTerm) ||
          uniqueIdentifier.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default ManagementsSelect;
